import React, { useState, useEffect } from "react";
import {
  DialogContent,
  Button,
  Grid,
  Typography,
  IconButton,
  Dialog,
} from "@mui/material";

import { DialogTitle, DialogActions, Box, Divider } from "@mui/material";
import {
  Close as CloseIcon,
  Logout as LogoutIcon,
  DevicesOther as DevicesIcon,
} from "@mui/icons-material";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSnackbar } from "notistack5";
import ResendValidity from "src/components/timer/ResendValidity.jsx";
import {
  loginOtpVerify,
  loginNetworkCall,
  verifyForgotPasswordOtp,
  logoutAllDevices,
} from "src/Api/auths.js";
import { encryptData } from "src/utils/encryptcookie";
import { navigateByRole } from "src/utils/roles/roles-condition";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { getDeviceInfo } from "../../../utils/deviceInfo";
import { getDeviceId } from "../../../utils/getDeviceId";

const OTP_TIME_LIMIT = 10 * 60;
// const OTP_TIME_LIMIT = 30

const AuthOtp = ({
  userEmail,
  userPassword,
  handleClose = () => {},
  isForgot,
  flowId,
}) => {
  const [tabValue, setTabValue] = useState(0);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [canResend, setCanResent] = useState(false);
  const otpInputRefs = [];
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [otpResponse, setOtpResponse] = useState();
  const [currentFlowId, setCurrentFlowId] = useState(flowId);

  useEffect(() => {
    if (flowId) setCurrentFlowId(flowId);
  }, [flowId]);

  const [timer, setTimer] = useState(OTP_TIME_LIMIT);
  const isSubmitValid = timer == 0 || otp.includes("");

  const handleChange = (_event, newValue) => {
    setTabValue(newValue);
  };

  // timer
  const handleTimerEnd = () => {
    setCanResent(true);
    setTimer(0);
  };

  async function resendOtp() {
    const response = await loginNetworkCall({
      username: userEmail,
      password: userPassword,
    });
    if (response.status) {
      if (response.flowId) {
        setCurrentFlowId(response.flowId);
      }
      enqueueSnackbar("Otp has been resend", {
        variant: "success",
        onClick: (event, key) => {
          closeSnackbar(key); // Dismiss notification on tap
        },
      });
    } else {
      enqueueSnackbar(response.message, {
        variant: "error",
        onClick: (event, key) => {
          closeSnackbar(key); // Dismiss notification on tap
        },
      });
    }
    setTimer(OTP_TIME_LIMIT);
  }

  const handleOtpChange = (index, event) => {
    const otpValue = event.target.value;

    if (isNaN(otpValue) || otpValue == " ") {
      return;
    }
    const otpCopy = [...otp];
    otpCopy[index] = otpValue;
    setOtp(otpCopy);
    if (otpValue && otpInputRefs[index + 1]) {
      otpInputRefs[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otp[index] && otpInputRefs[index - 1]) {
      otpInputRefs[index - 1].focus();
    }
  };

  useEffect(() => {
    if (otpInputRefs[0]) {
      otpInputRefs[0].focus();
    }
  }, []);

  const confirmDeleteAccounts = () => {
    loginSuccess(otpResponse);
    logoutAllDevices(otpResponse);
  };

  async function handleOtpSubmit() {
    if (true) {
      setSubmitLoading(true);
      const otpN = otp.join("");
      const deviceId = getDeviceId();
      
      let response;
      if (isForgot) {
        response = await verifyForgotPasswordOtp({
          email: userEmail,
          otp: otpN,
        });
      } else {
        // const deviceInfo =  getDeviceInfo()
        const deviceInfo = await getDeviceInfo();
        // deviceInfo.userIp = ipInfo
        response = await loginOtpVerify({
          username: userEmail,
          otp: otpN,
          deviceId,
          deviceInfo,
          flowId: currentFlowId,
        });
      }

      setOtpResponse(response);

      if (response.status == 2) {
        // if (response.hasLimitExceed) {
        //   setConfirmDelete(true);
        // } else {
          loginSuccess(response);
        // }
      } else if (response.status) {
        enqueueSnackbar(response.message, {
          variant: "success",
          onClick: (event, key) => {
            closeSnackbar(key); // Dismiss notification on tap
          },
        });
        handleClose();
      } else {
        enqueueSnackbar(response.message, {
          variant: "error",
          onClick: (event, key) => {
            closeSnackbar(key); // Dismiss notification on tap
          },
        });
      }
    }
    setSubmitLoading(false);
  }


  const loginSuccess = async (response) => {
    encryptData("_b60-g6fr_plus", response);
    enqueueSnackbar(response.message, {
      variant: "success",
      onClick: (event, key) => {
        closeSnackbar(key); // Dismiss notification on tap
      },
    });

    setTimeout(() => {
      navigate(navigateByRole(response?.role), { replace: true });
    }, 50);
    handleClose();
  };

  return (
    <DialogContent sx={{ padding: 0, display: "flex" }}>
      {confirmDelete && (
        <DeviceLogout
          confirmDeleteAccounts={confirmDeleteAccounts}
          onClose={() => {
            setConfirmDelete(false);
          }}
        />
      )}
      <Grid
        item
        xs={4}
        sx={{
          backgroundColor: "#8B0203",
          padding: "20px",
          display: "flex",
          flexBasis: "70%",
          flexDirection: "column",
          justifyContent: "center",
          color: "white",
          textAlign: "left",
          overflow: "auto",
          paddingBottom: "0px",
        }}
      >
        {/* <h2 className="text-[26px] font-[700] leading-[36px] mb-[1rem]">Schedule your <br /> <span style={{ color: "#FF898A" }}>Demo</span> now!</h2> */}
        <h2 className="text-[26px] font-[700] leading-[36px] mb-[1rem] mt-[2rem]">
          {" "}
          Sign In
        </h2>
        <h3 className="text-[16px] font-[600] mb-[1rem]">
          Please enter your account details.
        </h3>
        <div className="mt-2 w-full">
          <Slider {...settings}>
            {images.map((img, index) => (
              <div key={index}>
                <img
                  src={img}
                  alt="Flight deals"
                  className="rounded-lg inline-block mb-3 h-[302px] object-cover w-full"
                  style={{
                    clipPath:
                      "polygon(48% 0, 100% 0, 100% 90%, 88% 100%, 0 99%, 0 0)",
                  }}
                />
              </div>
            ))}
          </Slider>
        </div>
      </Grid>

      {/* Right Side - White Form */}
      <Grid item xs={7} sx={{ padding: "20px", position: "relative" }}>
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: "10px",
            top: "10px",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* <h3 className="text-[16px] font-[700] mt-[2rem]">
        Tell us a bit about you!
      </h3> */}

        <div className="flex justify-center items-center mt-[3rem] mb-[2rem] "></div>

        {/* <div className="flex items-center justify-between gap-[30px]">
          <TextField
            fullWidth
            //   value={"demoValue.firstName"}
            //   onChange={handleInputChange}
            name="firstName"
            size="small"
            //   error={errorMsg.firstName}
            //   helperText={errorMsg?.firstName}
            // placeholder="Username*"
            variant="outlined"
            sx={{
              marginTop: "10px",
              "& .MuiInputBase-input": {
                padding: "15px",
              },
              boxShadow: "0px 0px 6px 0px #0000000A;",
            }}
          />
            <TextField
            fullWidth
            //   value={"demoValue.firstName"}
            //   onChange={handleInputChange}
            name="firstName"
            size="small"
            //   error={errorMsg.firstName}
            //   helperText={errorMsg?.firstName}
            // placeholder="Username*"
            variant="outlined"
            sx={{
              marginTop: "10px",
              "& .MuiInputBase-input": {
                padding: "15px",
              },
              boxShadow: "0px 0px 6px 0px #0000000A;",
            }}
          />
            <TextField
            fullWidth
            //   value={"demoValue.firstName"}
            //   onChange={handleInputChange}
            name="firstName"
            size="small"
            //   error={errorMsg.firstName}
            //   helperText={errorMsg?.firstName}
            // placeholder="Username*"
            variant="outlined"
            sx={{
              marginTop: "10px",
              "& .MuiInputBase-input": {
                padding: "15px",
              },
              boxShadow: "0px 0px 6px 0px #0000000A;",
            }}
          />
            <TextField
            fullWidth
            //   value={"demoValue.firstName"}
            //   onChange={handleInputChange}
            name="firstName"
            size="small"
            //   error={errorMsg.firstName}
            //   helperText={errorMsg?.firstName}
            // placeholder="Username*"
            variant="outlined"
            sx={{
              marginTop: "10px",
              "& .MuiInputBase-input": {
                padding: "15px",
              },
              boxShadow: "0px 0px 6px 0px #0000000A;",
            }}
          />
        </div> */}

        <div className="flex items-center justify-between gap-[20px]">
          {otp.map((otpValue, index) => (
            <input
              className="w-[55px] h-[55px] text-center border-2 rounded-lg border-[#CB2B2C]"
              key={index}
              type="text"
              maxLength="1"
              required={true}
              value={otpValue}
              onChange={(event) => handleOtpChange(index, event)}
              onKeyDown={(event) => handleOtpKeyDown(index, event)}
              // onPaste={handleOtpPaste}
              ref={(ref) => (otpInputRefs[index] = ref)}
            />
          ))}
        </div>

        <div className="flex  items-center mt-2 text-[#272727] text-[12px] font-[500] h-[50px]">
          {canResend && (
            <>
              Didn’t received OTP?
              <Button
                onClick={resendOtp}
                className="text-[#CB2B2C] !hover:bg-white"
              >
                Resend OTP
              </Button>
            </>
          )}
        </div>

        <ResendValidity time={timer} onTimerEnd={handleTimerEnd} />
        {/* --------------------------------------MOBILE---------------------------- */}
        <div className="flex mt-[5px] items-center">
          <div className="mt-[5px] basis-[30%]">
            {/* <CountrySelect
          selectedCountry={countryInfo}
          setSelectedCountry={setCountryInfo}
          name={"countryCode"} /> */}
          </div>
        </div>

        <Typography
          variant="caption"
          sx={{
            marginTop: "2rem",
            fontSize: "12px",
            fontWeight: "500",
            display: "block",
            textAlign: "center",
            color: "#272727",
          }}
        >
          Didn’t have an account?{" "}
          <a
            href="/registration-form"
            className="p-0 no-underline text-[#CB2B2C] font-[600]"
          >
            Register Now
          </a>
        </Typography>

        <Button
          disabled={submitLoading}
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#CB2B2C",
            color: "white",
            fontWeight: "bold",
            marginTop: "15px",
            "&:hover": { backgroundColor: "#A00000" },
          }}
          onClick={handleOtpSubmit}
        >
          Submit
        </Button>
      </Grid>
    </DialogContent>
  );
};

export default AuthOtp;

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
};
const images = [
  "/Image/home/partner_back_img_1.webp",
  "/Image/home/partner_back_img_2.webp",
  "/Image/home/partner_back_img_3.webp",
];

const DeviceLogout = ({ confirmDeleteAccounts, onClose }) => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "16px",
          boxShadow: "0 24px 48px rgba(0, 0, 0, 0.12)",
          overflow: "visible",
        },
      }}
    >
      {/* Dialog Header */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 1,
          pt: 3,
          px: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 48,
              height: 48,
              borderRadius: "12px",
              backgroundColor: "error.light",
              color: "error.contrastText",
            }}
          >
            <DevicesIcon sx={{ fontSize: 24 }} />
          </Box>
          <Typography
            variant="h5"
            component="h2"
            sx={{
              fontWeight: 600,
              color: "text.primary",
            }}
          >
            Logout Other Devices
          </Typography>
        </Box>

        {onClose && (
          <IconButton
            onClick={onClose}
            sx={{
              color: "grey.400",
              "&:hover": {
                backgroundColor: "grey.100",
                color: "grey.600",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <Divider sx={{ mx: 3 }} />

      {/* Dialog Content */}
      <DialogContent sx={{ px: 3, py: 3 }}>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            lineHeight: 1.6,
            mb: 2,
          }}
        >
          This will sign you out from all other devices where you're currently
          logged in. You'll need to sign in again on those devices.
        </Typography>

        <Box
          sx={{
            backgroundColor: "warning.light",
            border: "1px solid",
            borderColor: "warning.main",
            borderRadius: "8px",
            p: 2,
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "white",
            }}
          >
            ⚠️ Important: This action cannot be undone. Make sure you have
            access to your login credentials for other devices.
          </Typography>
        </Box>
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 1,
          gap: 2,
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="outlined"
          color="error"
          onClick={onClose}
          startIcon={<LogoutIcon />}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            py: 1.5,
            boxShadow: "0 4px 12px rgba(244, 67, 54, 0.3)",
            "&:hover": {
              boxShadow: "0 6px 16px rgba(244, 67, 54, 0.4)",
              transform: "translateY(-1px)",
            },
            transition: "all 0.2s ease-in-out",
          }}
        >
          Close
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={confirmDeleteAccounts}
          startIcon={<LogoutIcon />}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            py: 1.5,
            boxShadow: "0 4px 12px rgba(244, 67, 54, 0.3)",
            "&:hover": {
              boxShadow: "0 6px 16px rgba(244, 67, 54, 0.4)",
              transform: "translateY(-1px)",
            },
            transition: "all 0.2s ease-in-out",
          }}
        >
          Logout All Devices
        </Button>
      </DialogActions>
    </Dialog>
  );
};
